import './App.scss';

// import DotRingComponent from './components/DotRingComponent/DotRingComponent';
import DotRingComponentTest from './components/DotRingComponent/DotRingComponentTest';
import NavbarComponent from './components/NavbarComponent/NavbarComponent';

import MainPage from './pages/MainPage/MainPage';
import ConstructionPage from './pages/ConstructionPage/ConstructionPage';
import ProjectPage10Latest from './pages/ProjectPages/ProjectPage10Latest';
import ProjectPage7Shifts from './pages/ProjectPages/ProjectPage7Shifts';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavbarComponent />
        {/* <DotRingComponent /> */}
        <DotRingComponentTest />
        <Routes>
          <Route path='/' element={<MainPage />} />
          <Route path='/10latest' element={<ProjectPage10Latest />} />
          <Route path='/7Shifts-hackathon' element={<ProjectPage7Shifts />} />
          <Route path='/under-construction' element={<ConstructionPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
